<template>
    <div>
        <h2>{{ $t("settings.channels.General setup") }}</h2>
        <b-form-group
            id="fieldset-platform"
            :label="$t('settings.channels.platform.label')"
            class="mt-1"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="platform"
        >
            <font-awesome-icon :icon="resolvePlatformIcon(channelData.provider, channelData.platform)" />
            {{ transformPlatformName(channelData.platform) }}
        </b-form-group>

        <validation-provider #default="{ errors }" name="name" rules="required">
            <b-form-group
                id="fieldset-name"
                :description="$t('settings.channels.name.description')"
                :label="$t('settings.channels.name.label')"
                :state="errors.length > 0 ? false : null"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="name"
            >
                <b-form-input
                    id="name"
                    v-model="channelData.name"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>

        <b-form-group
            id="fieldset-isHighPriority"
            :description="$t('settings.channels.is-high-priority.description')"
            :label="$t('settings.channels.is-high-priority.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="name"
        >
            <b-form-checkbox
                v-model="getSettingByName('priority').value"
                inline
                name="isHighPriority"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            v-show="channelData.platform.toLowerCase() !== 'email'"
            id="fieldset-automaticSignature"
            :description="$t('settings.channels.automatic-signature.description')"
            :label="$t('settings.channels.automatic-signature.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="automaticSignature"
        >
            <b-form-select
                v-model="getSettingByName('automaticSignature', 'none').value"
                :options="automaticSignatureOptions"
                name="automaticSignature"
            ></b-form-select>
        </b-form-group>

        <b-form-group
            id="fieldset-allowDeleteConversation"
            :description="$t('settings.channels.delete-conversation.description')"
            :label="$t('settings.channels.delete-conversation.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="name"
        >
            <b-form-checkbox
                v-model="getSettingByName('allowDeleteConversation').value"
                inline
                name="allowDeleteConversation"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>
        <b-form-group
            id="fieldset-mandatoryAssignActive"
            :description="$t('settings.channels.mandatory-assign.description')"
            :label="$t('settings.channels.mandatory-assign.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="name"
        >
            <b-form-checkbox
                v-model="getSettingByName('mandatoryAssignActive').value"
                inline
                name="mandatoryAssignActive"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>
        <b-form-group
            id="fieldset-readForAllUsers"
            :description="$t('settings.channels.read-for-all-users.description')"
            :label="$t('settings.channels.read-for-all-users.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="readForAllUsers"
        >
            <b-form-checkbox
                id="readForAllUsers"
                v-model="getSettingByName('readForAllUsers').value"
                inline
                name="readForAllUsers"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>
        <b-form-group
            id="fieldset-unassignmentAfterArchiving"
            :description="$t('settings.channels.unassignment-after-archiving.description')"
            :label="$t('settings.channels.unassignment-after-archiving.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="unassignmentAfterArchiving"
        >
            <b-form-checkbox
                id="unassignmentAfterArchiving"
                v-model="getSettingByName('unassignmentAfterArchiving').value"
                inline
                name="unassignmentAfterArchiving"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>
        <hr />
    </div>
</template>

<script>
import useChannelSettings from "../useChannelSettings";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import { transformPlatformName, resolvePlatformIcon } from "@/utils/channels";
import i18n from "@/libs/i18n";
import { BContainer, BCard, BFormGroup, BFormInput, BFormCheckbox, BFormFile, BFormSelect } from "bootstrap-vue";
import { computed } from "@vue/composition-api";

export default {
    components: {
        BContainer,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BCard,
        BFormFile,
        BFormSelect,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        channelData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            required,
        };
    },
    setup(props) {
        const { getSettingByName, getAutoSignatureOptions } = useChannelSettings(props.channelData);

        return {
            transformPlatformName,
            resolvePlatformIcon,
            getSettingByName,

            automaticSignatureOptions: computed(() => getAutoSignatureOptions()),
        };
    },
};
</script>
